import { handleEvent } from '../utils/events'

//Botón de talles
window.addEventListener('load', () => {
    const talles = document.querySelector('[data-name=talles]')
    if (!talles) return null
    const buttons = talles.querySelectorAll('.size-btn')

    buttons.forEach((btn) => {
        const { stock: _stock, size } = btn.dataset
        const stock = Number(_stock) || 0;

        const container = btn.closest('.sizes__container')
        const minusBtn = container.querySelector('.minus')
        const plusBtn = container.querySelector('.plus')
        const input = container.querySelector('.campo')
        const message = container.querySelector('.message')

        input.style.outline = 'none'
        input.placeholder = '0'
        input.min = 1
        input.max = stock
        input.value = ''

        input.addEventListener('keyup', (e) => {
            let val = Number(e.target.value)
            if (e.target.value === '') return null
            if (val < 1) val = 1
            if (val > stock) {
                message.style.display = 'block'
                message.innerText = '¡no hay stock disponible!'
                input.value = stock
                return
            }
            message.style.display = 'none'
            input.value = val
        })

        minusBtn.addEventListener('click', (e) => {
            e.preventDefault()
            let currentValue = Number(input.value)
            if (currentValue > 1) {
                input.value = currentValue - 1
                message.style.display = 'none'
            }
        })

        // Botón "+"
        plusBtn.addEventListener('click', (e) => {
            e.preventDefault()
            let currentValue = Number(input.value)
            if (currentValue < stock) {
                input.value = currentValue + 1
                message.style.display = 'none'
            } else {
                message.style.display = 'block'
                message.innerText = '¡no hay stock disponible!'
            }
        })

        window.talle[size] = btn

        if (stock === 0) {
            btn.disabled = true
            input.disabled = true
            minusBtn.disabled = true
            plusBtn.disabled = true
            input.value = 0
            btn.style.textDecoration = 'line-through'
            btn.style.background = 'none'
            btn.style.border = '1px solid #000'
        }
    });
});

// Seciones 'Descripción', 'Fotos' y 'Ficha Técnica'
const sections = [
    {
        button: `<span>Descripción</span>`,
        content: `<div class="details__specs">
      <div class="data_datails">${PRODUCT_DATA?.details}</div>
      <div class="specs_list"><p class="specs_title">Ficha Técnica</p>${PRODUCT_DATA?.specs
                .map(
                    (spec) => `
      <div class="spec">
         <p class="spec_name">${spec.FieldName} :</p>
         <p class="spec_value">${spec.FieldValues}</p>
      </div>
      `
                )
                .join('')}</div>
      </div>`,
    },
    {
        button: `<span>Fotos</span><i class="fa-solid fa-file-arrow-down"></i>`,
        content: usuario?.status === 'Logged' ? getImagesModal() : getImagesHtml(PRODUCT_DATA?.images),
    },
    {
        button: `<span>Ficha Técnica</span><i class="fa-solid fa-file-arrow-down"></i>`,
        content: usuario?.status === 'Logged' ? getInfoModal() : getInfoHtml(),
    },
]

// HTML en caso de haber sesion
function getImagesModal() {
    return `<div class="message__background" data-name="opened__message">
               <div class="message__container">
                  <button data-name="close__message" class="close__btn"><i class="fa-regular fa-circle-xmark"></i></button>
                  <div class="message__data">
                     <span class="message__title">¿Desea Descargar las Imagenes?</span>
                     <div class="message__buttons">
                        <button class="download__btn"><span>Descargar</span><i class="fa-solid fa-file-arrow-down"></i></button>
                        <button class="cancel__btn" data-name="close__message"><span>Cancelar</span><i class="fa-solid fa-xmark"></i></button>
                     </div>
                  </div>
               </div>
            </div>`
}

// HTML en caso de NO haber sesion
function getImagesHtml(images) {
    return images.map((image) => `<div class="img_cont"><img src="/uploads/${image}"/></div>`).join('')
}

// HTML en caso de haber sesion
function getInfoModal() {
    return `<div class="message__background" data-name="opened__message">
            <div class="message__container">
               <button data-name="close__message" class="close__btn"><i class="fa-regular fa-circle-xmark"></i></button>
               <div class="message__data">
                  <span class="message__title">¿Desea Descargar la Ficha Técnica y Talles?</span>
                  <div class="message__buttons">
                     <button class="download__btn"><span>Descargar</span><i class="fa-solid fa-file-arrow-down"></i></button>
                     <button class="cancel__btn" data-name="close__message"><span>Cancelar</span><i class="fa-solid fa-xmark"></i></button>
                  </div>
               </div>
            </div>
         </div>`
}

// HTML en caso de NO haber sesion
function getInfoHtml() {
    return `<div class="specs_list"><p class="specs_title">Ficha Técnica</p>${PRODUCT_DATA.specs
        .map(
            (spec) => `
      <div class="spec">
         <p class="spec_name">${spec.FieldName} :</p>
         <p class="spec_value">${spec.FieldValues}</p>
      </div>
      `
        )
        .join('')}</div>
      </div>`
}

let currentSection = 0

const detail = document?.querySelector('[data-name="details"]')
const detailBtn = detail?.querySelector('.details__btn')
const detailContent = detail?.querySelector('.details__content')

// Carga de Detalles
function updateDetails() {
    if (!detailBtn) return null
    detailBtn.innerHTML = ''
    sections.forEach(({ button }, i) => {
        const btn = document.createElement('button')
        btn.classList.add('detail_btn')
        btn.innerHTML = button
        detailBtn.appendChild(btn)
        if (i === currentSection) {
            btn.classList.add('current_section')
            btn.style.background = '#86b83d'
        }
        btn.addEventListener('click', (e) => {
            currentSection = i
            updateDetails()
        })
    })

    if (detailContent) detailContent.innerHTML = sections[currentSection].content
    if (usuario?.status === 'Logged') {
        MessageViewer()
    }
    if (sections[currentSection].onLoad) sections[currentSection].onLoad()
}

//Muestra mensaje de descarga en pantalla
function MessageViewer() {
    const detailContent = document.querySelector('.details__content')
    const messages = detailContent.querySelectorAll('[data-name="opened__message"]')

    if (!messages.length) return

    messages.forEach((message) => {
        const closeButton = message.querySelectorAll('[data-name="close__message"]')
        closeButton.forEach((btn) => {
            btn.addEventListener('click', () => {
                currentSection = 0
                updateDetails()
            })
        })
    })
}

updateDetails()

// Enviar al carrito
const botonEnviar = document.getElementById('enviar')
if (botonEnviar) {
    botonEnviar.addEventListener('click', function () {
        // Recolectar items con cantidad > 0
        const items = Object.values(window.talle)
            .map((btn) => {
                const container = btn.closest('.sizes__container')
                const input = container.querySelector('.campo')
                const cantidad = Number(input.value) || 0
                return { btn, cantidad }
            })
            .filter((d) => d.cantidad > 0)
            .map(({ btn, cantidad }) => ({
                id: Number(btn.dataset.id),
                sku: btn.dataset.code,
                stock: Number(btn.dataset.stock),
                cantidad
            }))

        if (!items.length) return

        // Tomar el código del primer item como 'code'
        const code = items[0].sku.split('.')[0]

        // Evento fire-and-forget
        const ev = {
            name: 'addedToCartObjectIDs',
            algolia_event: 'addedToCartObjectIDs',
            url: window.location.pathname,
            payload: { code, items },
        }
        handleEvent(ev, undefined, { require_location: true })

        Object.values(window.talle).forEach((t) => {
            if (t) {
                const campo = t.closest('.sizes__container').querySelector('.campo')
                campo.value = ''
            }
        })
    })
}
